<template>
  <div style="width: 90vw">
    <el-container class="contain-6" style="padding: 25px 25px">


      <div class="bbb">

        <el-header style="display: flex;height: 40px;">

          <el-button size="mini"
                     style="height: 30px;background-color: #f4f4f5;color: black"
                     @click="search()" icon="el-icon-refresh">
            刷新
          </el-button>
          <el-button
              size="mini" style="height: 30px;background-color: #f4f4f5;color: black"
              @click="form.name='';form.divisionScale=0.01; form.id =null;dialogFormVisible=true">添加父公司
          </el-button>
        </el-header>
        <el-dialog title="添加主体" :visible.sync="dialogFormVisible">
          <el-form :model="form" :label-width="formLabelWidth" style="margin-right: 60px">


            <el-form-item label="名称:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
              <el-input v-model="form.name" autocomplete="off" style="width: 300px"></el-input>
            </el-form-item>

            <el-form-item label="比例:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
              <el-input-number v-model="form.divisionScale" autocomplete="off" :precision="3" :step="0.001"
                               :max="100"></el-input-number>
            </el-form-item>


          </el-form>


          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="addCompany">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="添加子账户" :visible.sync="dialogFormVisible2">
          <el-form :model="form2" :label-width="formLabelWidth" style="margin-right: 60px">

            <el-form-item label="父编号:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
              <el-input v-model="form2.parantId" autocomplete="off" style="width: 300px" disabled></el-input>
            </el-form-item>
            <el-form-item label="父名称:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
              <el-input v-model="form2.parantName" autocomplete="off" style="width: 300px" disabled></el-input>
            </el-form-item>

            <el-form-item label="父比例:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
              <el-input-number v-model="form2.scale"
                               :max="100" disabled></el-input-number>
            </el-form-item>


            <el-form-item label="子名称:" :rules="[{ required: true, message: '年龄不能为空'}, ]">
              <el-input v-model="form2.subName" autocomplete="off" style="width: 300px"></el-input>
            </el-form-item>


          </el-form>


          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible2 = false">取 消</el-button>
            <el-button type="primary" @click="addChildren">确 定</el-button>
          </div>
        </el-dialog>


        <el-dialog title="编辑子账户" :visible.sync="dialogFormVisible3">
          <el-table      :data="formSub">

            <el-table-column
                prop="id"
                label="子公司编号"

            >
            </el-table-column>
            <el-table-column
                prop="subCompanyName"
                label="子公司名称"

            >
            </el-table-column>
            <el-table-column label="操作" >
              <template slot-scope="scope">
            <el-button
                size="mini"
                type="danger"
                @click="subDelete( scope.row)">删除
            </el-button>
              </template>
            </el-table-column>
          </el-table>


        </el-dialog>

        <el-table
            ref="tableData1"
            :data="tableData"
            stripe
            border
            max-height="79vh"
            height="79vh"
            style="margin-top: 11px"
            :header-cell-style="{background:'rgb(244,244,245)',color:'#323335'}"
            size="mini"
            v-loading="loading"
            highlight-current-row
        >

          <el-table-column
              align="center"
              type="selection"
              width="44">
          </el-table-column>

          <el-table-column
              prop="id"
              label="主体编号"
              min-width="80"
          >
          </el-table-column>

          <el-table-column
              prop="company"
              label="父级公司"
              min-width="100"
          >
          </el-table-column>


          <el-table-column
              prop=""
              label="子公司"
              min-width="250"
          >

            <template slot-scope="{row}">

              <span v-for="item in row.data_value2" :key="item"> | {{ item.subCompanyName }} |</span>

            </template>
          </el-table-column>

          <el-table-column
              prop="kuangScale"
              label="框返比例"
              min-width="90"
          >
          </el-table-column>
          <el-table-column label="操作" min-width="190">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="addSub(scope.$index, scope.row)">添加子公司
              </el-button>

              <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <el-button
                  size="mini"
                  @click="handleEditSub(scope.$index, scope.row)">编辑子公司
              </el-button>
              <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>

        </el-table>


      </div>


    </el-container>

  </div>
</template>

<script>
export default {
  name: "GameBroad",

  data() {

    return {

      form2: {

        parantName: '',

        parantId: "",
        subName: ""

      },
      formLabelWidth: '80px',
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      isSort: true,
      form: {divisionScale: 0.01, name: ""},
      options2: ['+', '-', '*', '/'],
      newProp: '例如(进入游戏)',
      newPropValue: '',
      valProp2: '',
      valueSuan: '',
      colData: [{title: "账面消耗", istrue: true},
        {title: "实际消耗", istrue: false},
      ],
      colOptions: ["账面消耗"], //默认全选
      colSelect: ["账面消耗", "实际消耗"],
      valProp: '例如(1,下一关)',
      titleHeads: [{sta_value: "进入游戏", sta_view_value: "进入游戏"}, {
        sta_value: "下一关",
        sta_view_value: "进入下一关"
      }],
      list: [],
      value1: [],
      currentPage: 1,

      valueScene: '',
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      tableData: [],
      tableData2: [],
      optionsGame: [],
      valueGame: "",
      options3: [{
        value: '选项1',
        label: '7'
      }, {
        value: '选项2',
        label: '14'
      }, {
        value: '选项3',
        label: '30'
      }],
      value: 0,
      ecpmA: 300,
      value2: '',
      value3: 7
      , json_data: []
      , json_fields: {},
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: [],
      maxHeight: 800,
      formSub:[]

    }

  }, watch: {

    colOptions(valArr) {
      // alert("sss");
      var arr = this.colSelect.filter(i => valArr.indexOf(i) < 0); // 未选中
      this.colData.filter(i => {
        if (arr.indexOf(i.title) != -1) {
          i.istrue = false;
          this.$nextTick(() => {
            this.$refs.tableDataRef.doLayout();
          });
        } else {
          i.istrue = true;
          this.$nextTick(() => {
            this.$refs.tableDataRef.doLayout();
          });
        }
      });
    }
  }, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return "-"

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  }, methods: {
    subDelete(row){

      this.$axios
          .get('/kf/delData2/' + row.id, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '删除成功',
                type: 'success'
              });
this.dialogFormVisible3=false

              this.search()


            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })

    },

    handleEdit(index, row) {


      this.form.id = row.id

      this.form.name = row.company

      this.form.divisionScale = row.kuangScale

      this.dialogFormVisible = true

    }, handleEditSub(index, row) {

      this.formSub= row.data_value2

      this.dialogFormVisible3 = true


    },
    handleDelete(index, row) {

      this.$axios
          .get('/kf/delData/' + row.id, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '删除成功',
                type: 'success'
              });


              this.search()

            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })

    },
    addChildren() {


      this.$axios
          .post('/kf/saveData2', this.form2)

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '添加成功',
                type: 'success'
              });

              this.dialogFormVisible2 = false

              this.search()
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    addSub(a, b) {

      this.form2.parantId = b.id

      this.form2.parantName = b.company

      this.dialogFormVisible2 = true

      this.form2.scale = b.kuangScale

    },

    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },

    addCompany() {

      this.$axios
          .post('/kf/saveData', this.form)

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '添加成功',
                type: 'success'
              });

              this.dialogFormVisible = false
              this.search()
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    search() {

      this.$axios
          .get('/kf/findData', {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.tableData = successResponse.data.data

            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })

    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },

  mounted: function () {

    this.height = window.innerHeight;

    this.maxHeight = window.innerHeight - 250;

    this.search()

  }


}
</script>
<style>
.el-table .column-style {
  color: #4d7dd6;
  font-size: 12px;
  font-weight: bold;
}

.el-table .column-style3 {
  color: #d65055;
  font-size: 12px;
  font-weight: 600;
}

.el-table .column-style2 {
  color: #606266;
  font-size: 12px;

  border: 2px dashed #F00;
  border-right: 2px dashed #0F0 !important;
}

.el-progress-bar .el-progress-bar__inner {

  border-radius: inherit;

}

.el-progress-bar .el-progress-bar__outer {
  background-color: rgba(134, 116, 255, 0.54);
  border-radius: inherit;

}


.item {
  margin-top: 8px;
  margin-right: 10px;
  padding: 2px 2px;
}
</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 13px;
  height: 12px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;

  margin-top: 19px;
  min-height: 80vh;
}

</style>

<style scoped>

.new_s {

  font-family: Arial;
  /*color: #2E95FB;*/
  /*font-weight: 500*/

}


.old_s {
  font-family: Arial;
  /*color: #ff0000;*/
  /*font-weight: 400*/

}

.el-row {
  margin-bottom: 10px;
  justify-items: center;
  align-items: center;
  align-content: center;
  text-align: center;
  vertical-align: middle;
  vertical-align: center;


}

.el-col {

  justify-items: center;
  align-items: center;
  align-content: center;
  text-align: center;
  vertical-align: middle;
  vertical-align: center;


  border-radius: 4px;
}

.bg-purple-dark {
  /*background: #99a9bf;*/
  border: 1px solid blue;
}

.bg-purple {
  background: #d3dce6;
  padding-top: 10px;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {


  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 0px 0;
  background-color: #f9fafc;
}
</style>
<style scoped>

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}
</style>